module.exports = __webpack_public_path__ + "img/icoTwitter.52585dd6.png";